import mixpanel from "mixpanel-browser";
import _ from "lodash";

export class AttendanceBaseController {
    /* @ngInject */
    constructor($state, $q, $timeout, SignatureService) {
        this.$state = $state;
        this.$q = $q;
        this.$timeout = $timeout;
        this.SignatureService = SignatureService;
        this.showSignature = false;
        this.OVERLAY_TIMEOUT = 1500;
    }

    done() {
        let ctrl = this;
        mixpanel.track("Pressed done button", { company_sid: ctrl.grower.sid });
        ctrl.showDoneSpinner = true;
        ctrl.$state.go(
            ctrl.redirectState,
            { meeting_sid: ctrl.meeting.sid },
            { reload: ctrl.redirectState },
        );
    }

    $onInit() {
        let ctrl = this;
        ctrl.requiresSignature = _.some(
            _.map(ctrl.topics, "requires_signature"),
        );
    }

    handleSignatureUpdate(value) {
        let ctrl = this;
        ctrl.signatureImageData = value;
    }

    getSignatureResponse(participant, signatureImageData, organizerSid) {
        let ctrl = this;
        if (signatureImageData) {
            ctrl.showSignatureSpinner = true;
            return ctrl.SignatureService.create({
                signer: participant,
                image_data: signatureImageData,
                grower_organization: organizerSid,
            });
        } else {
            let deferred = ctrl.$q.defer();
            deferred.resolve(undefined);
            return deferred.promise;
        }
    }
}
